const API = process.env.REACT_APP_API_URL || 'http://localhost:8000';

export async function getSessionStatus(shortId, idToken) {
  const res = await fetch(`${API}/api/my/card/${shortId}/session`, {
    headers: { Authorization: `Bearer ${idToken}` },
  });
  if (!res.ok) throw new Error('session fetch failed');
  return res.json(); // { active, expiresAt?, viewCount }
}

export async function activateSession(shortId, durationHours, idToken) {
  const res = await fetch(`${API}/api/my/card/${shortId}/session`, {
    method: 'POST',
    headers: { Authorization: `Bearer ${idToken}`, 'Content-Type': 'application/json' },
    body: JSON.stringify({ durationHours }),
  });
  if (!res.ok) throw new Error('session activate failed');
  return res.json(); // { active, expiresAt, viewCount }
}

export async function deactivateSession(shortId, idToken) {
  const res = await fetch(`${API}/api/my/card/${shortId}/session`, {
    method: 'DELETE',
    headers: { Authorization: `Bearer ${idToken}` },
  });
  if (!res.ok) throw new Error('session deactivate failed');
  return res.json(); // { active: false }
}
